import * as GfFields from ".";

import { Column, Row } from "politicamente-informados-ds";

type IFields = {
  fields: IField[];
  setFieldValue: void;
  values: Record<string, any>;
};
type IField = {
  id: string;
  type: string;
  layoutGridColumnSpan?: number;
};

export default function Fields({ fields, setFieldValue, values }: IFields) {
  return (
    <Row fluid={true}>
      {fields.length > 0 &&
        fields.map((field: IField) => {
          const id = field?.id;
          const type = field?.type;
          const formExtraProps = { key: id, setFieldValue, value: values[id] };

          let fieldToRender = null;
          switch (type) {
            case "section": // read only block
              fieldToRender = <GfFields.Section {...field} key={id} />;
              break;
            case "consent":
              fieldToRender = (
                <GfFields.Consent {...field} {...formExtraProps} />
              );
              break;
            case "checkbox":
              fieldToRender = (
                <GfFields.Checkbox {...field} {...formExtraProps} />
              );
              break;
            case "radio":
              fieldToRender = <GfFields.Radio {...field} {...formExtraProps} />;
              break;
            case "email":
              fieldToRender = <GfFields.Text {...field} key={id} />;
              break;
            case "phone":
              fieldToRender = <GfFields.Text {...field} key={id} />;
              break;
            case "select":
              fieldToRender = <GfFields.Select {...field} key={id} />;
              break;
            case "text":
              fieldToRender = <GfFields.Text {...field} key={id} />;
              break;
            case "number":
              fieldToRender = (
                <GfFields.Text {...field} key={id} type={"number"} />
              );
              break;
            case "date":
              fieldToRender = (
                <GfFields.Text {...field} key={id} type={"date"} />
              );
              break;
            case "website":
              fieldToRender = <GfFields.Text {...field} key={id} />;
              break;

            case "hidden":
              fieldToRender = <GfFields.Hidden {...field} key={id} />;
              break;
            case "textarea":
              fieldToRender = <GfFields.Textarea {...field} key={id} />;
              break;
            case "fileupload":
              fieldToRender = <GfFields.File {...field} {...formExtraProps} />;
              break;
            default:
              if (process.env.NODE_ENV === "development") {
                fieldToRender = (
                  <pre
                    key={id}
                  >{`"${type}" GravityForm field is unsupported. ${JSON.stringify(
                    field,
                    null,
                    2
                  )}`}</pre>
                );
              } else {
                fieldToRender = <></>;
              }
              break;
          }

          return (
            <Column key={`holder-${id}`} lg={field?.layoutGridColumnSpan || 12}>
              {fieldToRender}
            </Column>
          );
        })}
    </Row>
  );
}
